import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const MainOurTeam = styled.div`
  background-image: linear-gradient(
    to bottom,
    ${props => props.theme.colors.grayLightest},
    rgba(243, 243, 243, 0)
  );
`;

const WrapperOurTeam = styled.div`
  margin: 0 auto;
  max-width: ${rem('1232px')};
  padding: ${rem('30px')} ${rem('18px')};
`;

const HeaderOurTeam = styled.header`
  margin-bottom: ${rem('15px')};
  text-align: center;
`;

const HeaderOurTeamAccordion = HeaderOurTeam.extend``;

const TitleOurTeam = styled.h2`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  text-transform: uppercase;
  margin-bottom: 0;
`;

const SummaryOurTeam = styled.p`
  font-size: ${rem('15px')};
  line-height: 1.4;
`;

const LayoutTeam = styled.div`
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  margin: 0 auto;
`;

const ItemTeam = styled.div`
  align-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  margin: ${rem('15px')} 0;
  text-align: center;
  width: 100%;

  ${mediaqueries.greaterThan('mobile')`
      margin: ${rem('20px')};
      width: ${rem('198px')};
    `};
`;

export {
  MainOurTeam,
  WrapperOurTeam,
  HeaderOurTeam,
  HeaderOurTeamAccordion,
  TitleOurTeam,
  SummaryOurTeam,
  LayoutTeam,
  ItemTeam
};
